import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";


import Axios from "axios";
import { URL_LIST_ALL } from "../../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";

import AkkhorLayout from "../../../layout/AkkhorLayout";
import AlertErrorForm from "../../../component/AlertErrorForm";
import MyEditor from "../../../component/MyEditor";
import SearchBoxModal from "../../../component/SearchBoxModal";
import NumberInput from "../../../component/NumberInput";

export default function Formbanghang() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [STATUS_OPTIONS, SET_STATUS_OPTIONS] = useState([]);

    const defaultdetail = {
        author_id: user.data.id,
        title: '',
        sotang: '',
        thuoclo: '',
        giaban: '',
        giaban: '',
        dongia: '',
        dientich: '',
        dientich2: '',
        dientich3: '',
        sowc: '',
        sophongngu: '',
        sophongkhach: '',
        tienich: '',
        huong: '',
        datetime_moban: '',
        note: '',
        status: 1
    }
    useEffect(() => {
        if (user?.access_token) {
            Axios.get(URL_LIST_ALL + "banghang_settings", user.config).then(async (res) => {
                if (res.data.status === "success") {
                    let new_list = [];
                    const data = res.data.data
                    data.forEach(item => {
                        new_list.push({
                            value: item.id,
                            label: item.title,
                            background_color: item.background_color,
                            text_color: item.text_color,
                            action: item.action
                        },)
                    });
                    SET_STATUS_OPTIONS(new_list);
                } else console.log(res.data.message);
            }).catch((err) => console.log(err));
        }
    }, [user]);

    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "banghang/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            // console.log(res.data.data)
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );
    let validForm = {
        title: Yup.string().trim().nullable().required('Vui lòng nhập mã căn').max(250, "Độ dài không quá 250 ký tự"),
        duan_id: Yup.string().trim().nullable().required('Vui lòng chọn dự án'),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];

            setLoading(true)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'banghang/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật bảng hàng thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'banghang', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới bảng hàng thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="du-an">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/du-an">Danh sách bảng hàng</Link>
                    </li>
                    <li>{id ? 'Sửa căn' : 'Thêm mới căn'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} căn</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-12 col-sm-6 form-group">
                                <label>Mã căn <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD S3702" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-sm-6 col-12 form-group">
                                <label>Thuộc dự án <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"duan"} alldata={"?limit=25"} placeholder="Chọn dự án" colvalue={'id'} colname={'title'}
                                    defaultValue={formik.values['duan_id']} name='duan_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('duan_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="duan_id"></AlertErrorForm>

                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tòa/Lô</label>
                                <input type="text" placeholder="VD:1" className="form-control height32" {...formik.getFieldProps("thuoclo")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tầng</label>
                                <input type="text" placeholder="VD:1" className="form-control height32" {...formik.getFieldProps("sotang")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Số phòng ngủ</label>
                                <input type="text" placeholder="VD:1" className="form-control height32" {...formik.getFieldProps("sophongngu")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Số phòng khách</label>
                                <input type="text" placeholder="VD:1" className="form-control height32" {...formik.getFieldProps("sophongkhach")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Số WC</label>
                                <input type="text" placeholder="VD:1" className="form-control height32" {...formik.getFieldProps("sowc")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Hướng nhà</label>
                                <input type="text" placeholder="VD: Đông Nam" className="form-control height32" {...formik.getFieldProps("huong")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Diện tích 1 (m2)</label>
                                <input type="text" placeholder="VD:100" className="form-control height32" {...formik.getFieldProps("dientich")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Diện tích 2 (m2)</label>
                                <input type="text" placeholder="VD:100" className="form-control height32" {...formik.getFieldProps("dientich2")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Diện tích 3 (m2)</label>
                                <input type="text" placeholder="VD:100" className="form-control height32" {...formik.getFieldProps("dientich3")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Giá bán</label>
                                <NumberInput value={formik.values['giaban']}
                                    onChange={(val) => formik.setFieldValue("giaban", val)}
                                    placeholder="Nhập số tiền" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Đơn giá</label>
                                <NumberInput value={formik.values['dongia']}
                                    onChange={(val) => formik.setFieldValue("dongia", val)}
                                    placeholder="Nhập số tiền" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Trạng thái</label>
                                <select
                                    className="form-control form-select-sm"
                                    {...formik.getFieldProps("status")}
                                >
                                    {STATUS_OPTIONS.map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}

                                </select>
                            </div>
                            <div className="col-12 form-group">
                                <label>Mô tả chi tiết bảng hàng</label>
                                <MyEditor height={350} key={Math.random()} initialValue={formik.values.description}
                                    onValue={(value) => value && formik.setFieldValue("description", value)}
                                />
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trạng thái: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("status")}>
                                    <option value="1" >Đang hoạt động</option>
                                    <option value="0" >Ngưng hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 mt-3" ></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Lưu bảng hàng</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
